
export const providerMap = [
  { id: 'google', name: 'Google' },
  { id: 'nodemailer', name: 'Email' },
]